<template>
  <q-select
    v-model="value_"
    :multiple="multiple"
    filterable
    :disabled="disabled"
    :placeholder="placeholder"
  >
    <q-option
      v-for="item in items"
      :key="item[valueField]"
      :label="item[displayField]"
      :value="item[valueField]"
    />
  </q-select>
</template>

<script>
  export default {
    name: "QModelSelector",

    props: {
      value: {
        required: true
      },
      items: {required: true, Type: Array},
      disabled: {type: Boolean, default: false},
      placeholder: {default: '', type: String},
      displayField: {default: 'caption', type: String},
      valueField: {default: 'id', type: String},
      multiple: {type: Boolean, default: false},
    },

    data() {
      return {
        value_: {},
      }
    },

    watch: {
      value_() {
        this.$emit('input', this.value_);
      },
      value() {
        this.value_ = this.value;
      }
    },
    created() {
      this.value_ = this.value;
    },

    methods: {
    }

  }
</script>

<style scoped>

</style>